import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActivities, clearActivities } from '../../../../actions/index';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';

export const ActivitySelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearActivities,
  dispatchGetActivities,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearActivities(), []);

  const onInputChangeActivity = (inputValue) => {
    const value = (inputValue || '').trim();
    const len = value.length;
    if (len < 4) return;

    const looksLikeId =
      !/\s/.test(value) && /\d/.test(value) && /^[A-Za-z0-9._-]+$/.test(value);

    const field = looksLikeId ? 'companyActivityId' : 'name';

    dispatchGetActivities({ query: [`${field}:${value}`] });
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChangeActivity}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

ActivitySelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetActivities: PropTypes.func.isRequired,
  dispatchClearActivities: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  noOptionsMessage: PropTypes.func,
};

ActivitySelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca por código o nombre de actividad',
  noOptionsMessage: undefined,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  options: MechanicalMaintenanceUnit.Activity.getIn([
    'all',
    'content',
    'content',
  ]).map(({ companyActivityId, id, name }) => ({
    value: id,
    label: `${companyActivityId} - ${name}`,
  })),
  loading: MechanicalMaintenanceUnit.Activity.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetActivities: getActivities,
  dispatchClearActivities: clearActivities,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivitySelect);
